import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './login-form/login-form.component';
import { AuthGuardService } from './auth-guard.service';
import { AboutComponent } from './about/about.component';
import { StandardLayoutComponent } from './layouts/standard-layout/standard-layout.component';
import { ViewerComponent } from './document/viewer/viewer.component';
import { RetrievalRedirectComponent } from './retrieval/retrieval-redirect/retrieval-redirect.component';

/**
 * Routes using standard layout (see standard-layout component)
 */
const standardLayoutRoutes: Routes = [
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'home', loadChildren: () => import('./retrieval/retrieval.module').then(m => m.RetrievalModule) },
  { path: 'home', loadChildren: () => import('./data-entry/data-entry.module').then(m => m.DataEntryModule) },
  { path: 'about', component: AboutComponent },
  { path: 'viewer', component: ViewerComponent, canActivate: [AuthGuardService] },
  { path: 'workflow', loadChildren: () => import('./workflow/workflow.module').then(m => m.WorkflowModule) },
  {
    path: 'retrieve', component: RetrievalRedirectComponent, // route-redirector to support URLs without /home (e.g. /retrieve instead of /home/retrieve)
    children: [
      { path: ':id', component: RetrievalRedirectComponent, outlet: 'template' }
    ]
  }
];

const routes: Routes = [
  { path: '', component: LoginFormComponent },
  { path: 'test', loadChildren: () => import('./test/test.module').then(m => m.TestModule) },
  {
    path: '', component: StandardLayoutComponent,
    children: standardLayoutRoutes
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }